import classNames from 'classnames'

export const UnderLinedButton = ({
  title,
  className,
  onClick = () => {},
  isClickEnabled = true,
  disableClassName = '',
  isB2B = false
}) => {
  const clickHandler = () => {
    if (isClickEnabled) onClick()
  }
  return (
    <div
      {...{
        className: classNames(
          isClickEnabled && 'font-bold w-fit text-[#0174D3]  cursor-pointer truncate',
          className,
          !isClickEnabled && 'font-bold text-[#97989B] no-underline ' + disableClassName,
          isB2B
            ? 'no-underline text-[#0E56A8] text-[14px] leading-[21px] font-noto-sans '
            : 'underline'
        ),
        onClick: clickHandler
      }}
    >
      {title}
    </div>
  )
}
